
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ResearchDeleteService } from './research-delete-service';

export const useDeleteResearch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (researchId: string) => {
      await ResearchDeleteService.deleteResearch(researchId);
    },
    onSuccess: () => {
      // Invalidate all research library related queries to ensure immediate UI updates
      queryClient.invalidateQueries({
        queryKey: ['research-library'],
      });
      
      // Also invalidate the more specific list queries that are actually used
      queryClient.invalidateQueries({
        queryKey: ['research-library-list'],
      });
      
      // Invalidate individual research item details
      queryClient.invalidateQueries({
        queryKey: ['research-item-details'],
      });
    },
    onError: (error) => {
      console.error('Failed to delete research:', error);
    },
  });
};
